import { render, staticRenderFns } from "./PlayerRushes.vue?vue&type=template&id=2fadbcec&"
import script from "./PlayerRushes.vue?vue&type=script&lang=js&"
export * from "./PlayerRushes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports